/**
 * @fileoverview Task priority helpers (MOR-696)
 *
 * Linear-style 0-4 priority scale shared by the side panel, calendar colour
 * map, and (later) the kanban board. Priority 0 ("None") is the absence of a
 * priority; 1 is the most urgent.
 */

import {
  SignalHigh,
  SignalLow,
  SignalMedium,
  AlertCircle,
  Minus,
  type LucideIcon,
} from "lucide-react";
import type { BadgeColor } from "@/ui/primitives/badge";

export interface PriorityMeta {
  value: number;
  label: string;
  icon: LucideIcon;
  /** Badge colour for the calendar / board surfaces. */
  color: BadgeColor;
}

/** Ordered 0 → 4. Index === priority value. */
export const TASK_PRIORITIES: ReadonlyArray<PriorityMeta> = [
  { value: 0, label: "No priority", icon: Minus, color: "gray" },
  { value: 1, label: "Urgent", icon: AlertCircle, color: "red" },
  { value: 2, label: "High", icon: SignalHigh, color: "orange" },
  { value: 3, label: "Medium", icon: SignalMedium, color: "amber" },
  { value: 4, label: "Low", icon: SignalLow, color: "blue" },
];

export function priorityMeta(
  priority: number | null | undefined,
): PriorityMeta {
  if (priority == null) return TASK_PRIORITIES[0];
  return TASK_PRIORITIES[priority] ?? TASK_PRIORITIES[0];
}
